var map = {
	"./0.svg": 3282,
	"./1688.png": 6615,
	"./amazon.png": 7378,
	"./amazon.svg": 7246,
	"./asiamart.svg": 3384,
	"./bukalapak.svg": 2776,
	"./chinabuybuy.png": 2353,
	"./instagram.svg": 7702,
	"./lazada.svg": 9749,
	"./offline.svg": 8551,
	"./shopee.svg": 6956,
	"./shopify.svg": 1168,
	"./taobao.png": 4192,
	"./tiktok.svg": 4664,
	"./tmall.png": 5958,
	"./tokopedia.svg": 8432,
	"./unknown.svg": 7632,
	"./woocommerce.svg": 5254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6228;